module.exports = __webpack_public_path__ + "static/media/people_suits.e10c60d7.png";